import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative min-h-[50vh] sm:min-h-screen w-full flex items-center justify-center overflow-hidden hero-section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 w-full h-full">
        {/* Background Image */}
        <div className="absolute inset-0 hero-bg-image"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-background/60 to-background/40 md:from-background/90 md:via-background/70 md:to-background/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 flex flex-col justify-between h-full min-h-[50vh] sm:min-h-screen">
        
                 {/* 🔹 Top Heading */}
         <div className="pt-5 sm:pt-0 md:pt-0 lg:pt-0 text-center">
                     <motion.h1 
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.8, delay: 0.2 }}
             className="text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-text-primary leading-tight px-2 sm:px-4"
           >
            Endoscopic and Surgical <span className="block md:inline text-primary">Products Distributor</span>
          </motion.h1>
        </div>

        {/* 🔹 Bottom Section */}
        <div className="text-center space-y-2 sm:space-y-4 md:space-y-6 pb-3 sm:pb-12 md:pb-20 lg:pb-24">
          {/* Features */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
                         className="flex flex-wrap justify-center gap-1 sm:gap-4 text-sm font-medium mt-3 sm:mt-12 md:mt-20 lg:mt-24 px-4 sm:px-4"
          >
            <motion.div 
              whileHover={{ scale: 1.05, y: -2 }}
                             className="flex items-center space-x-1 sm:space-x-2 md:space-x-3 px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full border border-border/30 shadow-lg 
                          bg-gradient-to-r from-green-600 to-green-500 backdrop-blur-md"
            >
              <Icon name="Shield" size={12} className="sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" />
              <span className="text-white font-semibold text-xs sm:text-base">GDPMD Certified</span>
            </motion.div>

            <motion.div 
              whileHover={{ scale: 1.05, y: -2 }}
                             className="flex items-center space-x-1 sm:space-x-2 md:space-x-3 px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full border border-border/30 shadow-lg 
                          bg-gradient-to-r from-purple-600 to-purple-500 backdrop-blur-md"
            >
              <Icon name="Award" size={12} className="sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" />
              <span className="text-white font-semibold text-xs sm:text-base">12+ Years Experience</span>
            </motion.div>

            <motion.div 
              whileHover={{ scale: 1.05, y: -2 }}
                             className="flex items-center space-x-1 sm:space-x-2 md:space-x-3 px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full border border-border/30 shadow-lg 
                          bg-gradient-to-r from-orange-600 to-orange-500 backdrop-blur-md"
            >
              <Icon name="Users" size={12} className="sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" />
              <span className="text-white font-semibold text-xs sm:text-base">Trusted by 500+ Surgeons</span>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
